module.exports = __webpack_public_path__ + "img/ZB53详情页_15.56805a9f.jpg";